<script>

    import UtilsMethods from '../$methods/utils.methods'

    export let provider = null
    export let service = null

    $: provider && setServices()

    const servicesList = UtilsMethods.getServices()

    let services = ['Selecciona un proveedor']

    function setServices() {
        services = servicesList[provider]

        if(!services)
            return

        service = services[0]
    }

</script>

<div class="field">
    <label for="" class="label">Servicio</label>
    <div class="control">
        <div class="select">
            <select bind:value={service}>
                {#if services}
                    {#each services as serviceItem}
                        <option value="{ serviceItem }">{ serviceItem }</option>
                    {/each}
                {/if}
            </select>
        </div>
    </div>
</div>